/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingParallelSlotsQueryResponse, GetApiBookingParallelSlotsQueryParams } from "../entities/GetApiBookingParallelSlots";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBookingParallelSlots } from "../api/getApiBookingParallelSlots";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBookingParallelSlotsQueryKey = (params: GetApiBookingParallelSlotsQueryParams) => [{ url: '/api/booking/parallel/slots' }, ...(params ? [params] : [])] as const

export type GetApiBookingParallelSlotsQueryKey = ReturnType<typeof getApiBookingParallelSlotsQueryKey>

export function getApiBookingParallelSlotsQueryOptions(params: GetApiBookingParallelSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBookingParallelSlotsQueryKey(params)
        return queryOptions<GetApiBookingParallelSlotsQueryResponse, ResponseErrorConfig<Error>, GetApiBookingParallelSlotsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBookingParallelSlots(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает комбинации времени и двух мастеров, доступных одновременно
 * @summary Получить доступные слоты для параллельной записи
 * {@link /api/booking/parallel/slots}
 */
export function useGetApiBookingParallelSlots<TData = GetApiBookingParallelSlotsQueryResponse, TQueryData = GetApiBookingParallelSlotsQueryResponse, TQueryKey extends QueryKey = GetApiBookingParallelSlotsQueryKey>(params: GetApiBookingParallelSlotsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBookingParallelSlotsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBookingParallelSlotsQueryKey(params)
         

         const query = useQuery({
          ...getApiBookingParallelSlotsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}